module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-row-own.c9d5858d.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-row-own.png
// module id = 3844
// module chunks = 11